import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from 'src/App';
import { AuthProvider } from 'src/Firebase/context';
import { GlobalContextProvider } from 'src/contexts/Global';
import { UtilProvider } from 'src/contexts/Util';
import { SharedContextProvider } from 'src/contexts/SharedContext';
import BUILD_INFO from 'src/consts/URLS/data.json';
import { RestaurantActiveProvider } from 'src/contexts/RestaurantActiveContext';

import reportWebVitals from './reportWebVitals';

import './index.css';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import installApiTracing from 'src/utils/installApiTracing';
import { REST_MNGT_ENDPOINT } from 'src/config';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.2,
  });
}

installApiTracing({
  client_app: 'meny-manage',
  client_version: process.env.NODE_ENV,
  axios_instance: axios,
  api_prefixes: [REST_MNGT_ENDPOINT],
});

console.log('hello from menymeny.com', BUILD_INFO.GIT_COMMIT);

if (process.env.NODE_ENV !== 'development') {
  // console.log = () => {};
  // console.assert = () => {};
  // console.warn = () => {};

  if (window.location.href.search(/web.app/) > 0) {
    // console.debug = () => {};
    // console.error = () => {};
  }

  alert = () => {};
}

ReactDOM.render(
  <>
    <React.StrictMode>
      <UtilProvider>
        <BrowserRouter>
          <AuthProvider>
            <SharedContextProvider>
              <GlobalContextProvider>
                <RestaurantActiveProvider>
                  <CssBaseline />
                  <App />
                </RestaurantActiveProvider>
              </GlobalContextProvider>
            </SharedContextProvider>
          </AuthProvider>
        </BrowserRouter>
      </UtilProvider>
    </React.StrictMode>
  </>,
  document.getElementById('root')
);

reportWebVitals(console.log);
